import React from 'react'
import { DropdownOptionSelection, FieldProps } from '../../../../../../@types/types'
import DropdownSelect from '../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { BuildingTypeOption } from '../../../../../../@types/dropdown-types'
import { getDefaultClasses } from '../../../../../../utils/style-utils'
import { OtherFacilitiesWrapperProps } from '../../otherFacilities/OtherFacilities'
import { useTranslation } from 'react-i18next'
import { useIsRequiredProperty } from '../../../../../../services/validation/requiredFieldsUtils/useIsRequiredProperty'

export type BuildingTypeCategoryLabel = 'apartment' | 'house' | 'object' | 'shortTermLiving'
export type BuildingTypeValidationResult = {
  buildingType?: string[]
}
export type BuildingTypeAdditionalProps = {
  buildingTypeOptions: BuildingTypeOption[]
  translationKeyGroup?: BuildingTypeTranslationKey
  wrapperClassName?: string
  categoryLabel?: BuildingTypeCategoryLabel
}

export enum BuildingTypeTranslationKey {
  DEFAULT = 'buildingType.defaultTypes',
  SHORT_TERM_ACCOMMODATION = 'buildingType.shortTermAccommodationTypes',
}
const BuildingType: React.FC<FieldProps<BuildingTypeValidationResult> & BuildingTypeAdditionalProps> = ({
  buildingTypeOptions,
  translationKeyGroup = BuildingTypeTranslationKey.DEFAULT,
  insertionData,
  validationMessages,
  screenName,
  wrapperClassName = 'grid-item one-whole',
  categoryLabel = 'object',
  onChange,
}) => {
  const { t } = useTranslation()
  const isRequiredBuildingType = useIsRequiredProperty('buildingType')
  const shouldAllowEmpty = !isRequiredBuildingType
  const filteredBuildingTypeOptions = shouldAllowEmpty
    ? buildingTypeOptions
    : buildingTypeOptions.filter((option) => option !== BuildingTypeOption.NO_INFORMATION)

  return (
    <div className={`${wrapperClassName}`}>
      <DropdownSelect
        id='building-type'
        name='buildingType'
        label={`buildingType.label.${categoryLabel}`}
        value={insertionData.buildingType?.value}
        noInformation={shouldAllowEmpty ? BuildingTypeOption.NO_INFORMATION : undefined}
        placeholder={
          shouldAllowEmpty ? undefined : t('wizard.screen.multimediaNewModalContent.pleaseSelect', 'Please select')
        }
        showPlaceholderOption={false}
        options={{
          translationKeyGroup,
          options: filteredBuildingTypeOptions,
        }}
        allowEmpty={shouldAllowEmpty}
        errors={validationMessages?.buildingType ?? []}
        onChange={(value: DropdownOptionSelection) => onChange({ screen: screenName, property: 'buildingType' }, value)}
      />
    </div>
  )
}

export const buildingTypeField =
  (
    category: BuildingTypeCategoryLabel,
    buildingTypes: BuildingTypeOption[],
    buildingTypeClassName = getDefaultClasses('left'),
    translationKeyGroup?: BuildingTypeTranslationKey
  ) =>
  (props: OtherFacilitiesWrapperProps) => (
    <BuildingType
      {...props}
      translationKeyGroup={translationKeyGroup}
      wrapperClassName={buildingTypeClassName}
      buildingTypeOptions={buildingTypes}
      categoryLabel={category}
    />
  )

export default BuildingType
